import { render, staticRenderFns } from "./VideoMessagePreview.vue?vue&type=template&id=554c7314&scoped=true&"
import script from "./VideoMessagePreview.vue?vue&type=script&lang=js&"
export * from "./VideoMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./VideoMessagePreview.vue?vue&type=style&index=0&id=554c7314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c7314",
  null
  
)

export default component.exports